import React from 'react'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import './EditUser.css'
import { useState } from 'react'
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useParams, Link, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import icon from '../../assets/images/i.png'

export const EditUser = () => {
  // to edit profile of user(Admin,HR,Interviewer)
  toast.configure()
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  const token = localStorage.getItem('token')

  const [data, setData] = useState()

  const [phone, setPhone] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [passwordError, setPasswordErr] = useState('')
  const params = useParams()

  // fetch data of candidate based on id
  const getData = async () => {
    await axios
      .post(
        Baseurl.nodeLocal + 'enduser/fetchProfileBasedOnID',

        {
          id: params.id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        setData(res.data.data[0])
        setPhone(res.data.data[0].contact)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // input onchange
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setData({ ...data, [name]: value })
  }

  // update profile
  const postData = async (e) => {
    e.preventDefault()
    await axios
      .post(
        Baseurl.nodeLocal + 'enduser/updateProfile',

        {
          id: params.id,
          name: data.name,
          contact: phone,
          password: data.password,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        })
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        })
        if (error.response.status === 401) {
          logout()
        }
      })
  }

  // password validation
  const handleValidation = (evnt) => {
    const passwordInputValue = evnt.target.value.trim()
    const passwordInputFieldName = evnt.target.name
    //for password
    if (passwordInputFieldName === 'password') {
      const uppercaseRegExp = /(?=.*?[A-Z])/
      const lowercaseRegExp = /(?=.*?[a-z])/
      const digitsRegExp = /(?=.*?[0-9])/
      const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/
      const minLengthRegExp = /.{8,}/
      const passwordLength = passwordInputValue.length
      const uppercasePassword = uppercaseRegExp.test(passwordInputValue)
      const lowercasePassword = lowercaseRegExp.test(passwordInputValue)
      const digitsPassword = digitsRegExp.test(passwordInputValue)
      const specialCharPassword = specialCharRegExp.test(passwordInputValue)
      const minLengthPassword = minLengthRegExp.test(passwordInputValue)
      let errMsg = ''
      if (passwordLength === 0) {
        errMsg = ''
      } else if (!uppercasePassword) {
        errMsg = 'At least one Uppercase'
      } else if (!lowercasePassword) {
        errMsg = 'At least one Lowercase'
      } else if (!digitsPassword) {
        errMsg = 'At least one digit'
      } else if (!specialCharPassword) {
        errMsg = 'At least one Special Characters'
      } else if (!minLengthPassword) {
        errMsg = 'At least minumum 8 characters'
      } else {
        errMsg = ''
      }
      setPasswordErr(errMsg)
    }
  }

  // to show/hide password
  const onMouseDown = () => {
    setShowPassword(!showPassword)
  }
  return (
    <>
      <Sidebar />
      <div className="container edituser mt-5 p-4">
        <div className="">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/home" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item ">
                <Link to="/userList" className="link text-primary">
                  Users
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Edit User
              </li>
            </ol>
          </nav>
        </div>
        {data ? (
          <div className="row mt-5">
            <div className="col-lg-4">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex flex-column align-items-center text-center">
                    <img
                      src={icon}
                      alt="Admin"
                      className="rounded-circle "
                      width="110"
                    />
                    <div className="mt-3">
                      <h4>{data.name}</h4>
                      <p className="text-secondary mb-1">{data.role}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="card">
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Name</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={data.name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Email</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      <input
                        type="text"
                        className="form-control"
                        name="email"
                        value={data.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Contact</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                      <PhoneInput
                        country={'in'}
                        value={phone}
                        onChange={setPhone}
                        enableSearch
                        // inputStyle={{ width: '25rem' }}
                        inputClass="form-control w-100"
                      />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-sm-3">
                      <h6 className="mb-0">Password</h6>
                    </div>
                    <div className="input-group col-md text-secondary">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        className="form-control"
                        aria-describedby="inputGroup-sizing-default"
                        name="password"
                        value={data.password}
                        onChange={handleChange}
                        onKeyUp={handleValidation}
                      />
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-default"
                        onMouseDown={onMouseDown}
                        onMouseUp={onMouseDown}
                      >
                        {showPassword ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </span>
                      {passwordError ? (
                        <h6 className="text-danger col-md-12 mt-2">
                          {passwordError}
                        </h6>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3"></div>
                    <div className="col-sm-9 text-secondary">
                      <input
                        type="button"
                        className="btn btn-primary px-4"
                        value="Save Changes"
                        onClick={postData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </>
  )
}
